

























































import {Component, Prop, Vue} from "vue-property-decorator";
import {SoldItem} from "@/interfaces/entities/SoldItem";
import {InventoryItem} from "@/interfaces/entities/InventoryItem";
import {Price} from "@/interfaces/entities/Price";
import {emojiFlag} from "@/util/emojiFlag";
import {tools} from "@/util/tools";

interface SSoldItem {
    retailPriceEdited: boolean;
    name: string;
    sizeValue: number;
    sizeUnit: string;
    validitySize:  number;
    validityUnit: string;
    packageType?: "unlimited" | "standard";
    prices: Array<Price>;
    retailPrices: Array<Price>;
}

@Component({})
export default class CardContent extends Vue {
    @Prop({required: true}) soldItem!: SoldItem | SSoldItem;
    @Prop({type: String}) type!: string;

    private get item(): Partial<SSoldItem> & Partial<SoldItem> {
        return this.soldItem;
    }

    //  inventory items carry their own size (0 for unlimited packs, so no
    //  truthiness checks here), sold items only carry a balance.
    get volume(): string {
        if (this.item.sizeValue !== undefined) return tools.getVolume(this.item as InventoryItem);
        return this.item.balance ? tools.getBalanceVolume(this.item.balance) : "";
    }

    get itemName(): string {
        return this.item.name || this.item.balance?.name || "";
    }

    get validity(): string {
        const size = this.item.validitySize ?? this.item.balance?.validitySize;
        const unit = this.item.validityUnit ?? this.item.balance?.validityUnit;
        return size === undefined ? "" : `${size} ${unit}`;
    }

    private getEmojiFlag(countryCode: string): string {
        return emojiFlag(countryCode, "🌏");
    }

    private formatActivatedAt(date: string | null): string {
        return date
            ? this.$options.filters?.dateFormat(date)
            : this.$t("general.pending") as string;
    }
}
